// extracted by mini-css-extract-plugin
export default {"container":"FpRKLcs7hS8UppFCD_3K","body":"WVE71H7xVHxM_vVXmbvB"};